/**
 * Úklid PWA z doby, kdy trenigo.cz servíroval stejný build jako aplikace (FR01
 * 20261001_LandingPage/002_Marketing, FR-09). Odpovídá dřívějšímu disablePwaOnMarketingHost()
 * v apps/web: odregistruje případný service worker na originu a smaže cache `workbox-*`, aby
 * návštěvník s dříve zaregistrovaným service workerem aplikace nedostával z cache aplikační shell.
 * Web sám žádný service worker neregistruje; na /sw.js je jen kill-switch (public/sw.js).
 *
 * Best-effort: selhání nesmí shodit vykreslení stránky. Vrací promise kvůli testům.
 */
export async function cleanupLegacyPwa(): Promise<void> {
  try {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if (typeof window !== 'undefined' && 'caches' in window) {
      const names = await window.caches.keys();
      await Promise.all(names.filter((name) => name.startsWith('workbox-')).map((name) => window.caches.delete(name)));
    }
  } catch {
    // Best-effort úklid - viz komentář výše.
  }
}
